import { render, staticRenderFns } from "./UpsellGroupProfile.vue?vue&type=template&id=50eb92e4"
import script from "./UpsellGroupProfile.vue?vue&type=script&lang=js"
export * from "./UpsellGroupProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports